import styled, { css } from 'styled-components';

export const AccordionContent = styled.div`
  & {
    position: relative;
    padding: 0.5rem 2rem;
    overflow: hidden;
  }
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const AccordionTrigger = styled.i``;

export const AccordionContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto;

  ${AccordionContent} {
    -webkit-transition: height 0.5s ease-in-out;
    -moz-transition: height 0.5s ease-in-out;
    -o-transition: height 0.5s ease-in-out;
    transition: height 0.5s ease-in-out;
    height: auto;
  }
  ${(props) =>
    props.collapsed
      ? css`
          ${AccordionContent} {
            padding: 0;
            height: 0;
          }
          ${AccordionTrigger} {
            color: var(--secondary-700);
          }
        `
      : css`
          ${AccordionTrigger} {
            color: var(--primary-700);
          }
        `}
`;
